// Convert an integer (1..3999) into a Roman numeral string. Standard
// subtractive form (IV not IIII, IX not VIIII).
//
// Used by Phase 67b's date-input mode on rk-special-date: customer picks
// a date in a native HTML date picker; the customiser converts to
// "DD · MM · YYYY" Roman numerals and that's what stitches.

const ROMAN_TABLE: Array<[number, string]> = [
  [1000, "M"],
  [900, "CM"],
  [500, "D"],
  [400, "CD"],
  [100, "C"],
  [90, "XC"],
  [50, "L"],
  [40, "XL"],
  [10, "X"],
  [9, "IX"],
  [5, "V"],
  [4, "IV"],
  [1, "I"],
];

export function toRoman(n: number): string {
  if (!Number.isFinite(n) || n < 1 || n > 3999) return "";
  let remaining = Math.floor(n);
  let out = "";
  for (const [value, glyph] of ROMAN_TABLE) {
    while (remaining >= value) {
      out += glyph;
      remaining -= value;
    }
  }
  return out;
}

/** Convert an HTML `<input type="date">` value (YYYY-MM-DD) to a
 *  "DD · MM · YYYY" Roman numeral string. Returns "" when the input
 *  is empty or malformed so the customiser's save-validation gate
 *  fires until a real date is picked. */
export function dateIsoToRoman(iso: string): string {
  if (!iso) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso.trim());
  if (!m) return "";
  const year = Number.parseInt(m[1], 10);
  const month = Number.parseInt(m[2], 10);
  const day = Number.parseInt(m[3], 10);
  if (
    !Number.isFinite(year) ||
    !Number.isFinite(month) ||
    !Number.isFinite(day) ||
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > 31
  ) {
    return "";
  }
  const dd = toRoman(day);
  const mm = toRoman(month);
  const yyyy = toRoman(year);
  if (!dd || !mm || !yyyy) return "";
  return `${dd} · ${mm} · ${yyyy}`;
}
